import { render, staticRenderFns } from "./dr-menu-vertical.vue?vue&type=template&id=3c65b5bd&"
import script from "./dr-menu-vertical.vue?vue&type=script&lang=js&"
export * from "./dr-menu-vertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports